/**
 * Popular recipe definitions for the Automations Rules tab.
 * Used to prefill new rules when the user clicks "Use Recipe".
 */

import type { AutomationRuleTriggerEvent } from './types';

export type PopularRecipeAction = {
  type: string;
  params?: Record<string, string>;
};

export type PopularRecipe = {
  id: string;
  title: string;
  description: string;
  triggerLabel: string;
  actionLabel: string;
  triggerEvent: AutomationRuleTriggerEvent;
  conditionSummary?: string;
  /** Actions to prefill; params key-value pairs. */
  actions: PopularRecipeAction[];
};

export const POPULAR_RECIPES: PopularRecipe[] = [
  {
    id: 'tag-new-client',
    title: 'Tag new client',
    description: 'Automatically apply a tag when a new client is created.',
    triggerLabel: 'Client created',
    actionLabel: 'Apply tag',
    triggerEvent: 'client_created',
    actions: [
      {
        type: 'assign_tag',
        params: { tag_ids: '' },
      },
    ],
  },
  {
    id: 'welcome-new-clients',
    title: 'Welcome New Clients',
    description:
      'Send a welcome email automatically when a new client is added.',
    triggerLabel: 'Client created',
    actionLabel: 'Send Mail template',
    triggerEvent: 'client_created',
    actions: [
      {
        type: 'send_template',
        params: { follow_up_template_id: '' },
      },
    ],
  },
  {
    id: 'first-session-reminder',
    title: 'First Session Reminder',
    description: 'Remind new clients about their first appointment.',
    triggerLabel: 'Tag: New Client',
    actionLabel: 'Send Mail template',
    triggerEvent: 'client_tag_added',
    conditionSummary: 'Tag is New Client',
    actions: [
      {
        type: 'send_template',
        params: { follow_up_template_id: '' },
      },
    ],
  },
  {
    id: 'crisis-support-follow-up',
    title: 'Crisis Support Follow-up',
    description: 'Send resources when the Crisis Support tag is applied.',
    triggerLabel: 'Tag: Crisis Support',
    actionLabel: 'Send Mail template',
    triggerEvent: 'client_tag_added',
    conditionSummary: 'Tag is Crisis Support',
    actions: [
      {
        type: 'send_template',
        params: { follow_up_template_id: '' },
      },
    ],
  },
  {
    id: 'send-intake-package',
    title: 'Send Intake Package',
    description: 'Get to know your clients and how to best work with them.',
    triggerLabel: 'Client added',
    actionLabel: 'Send Mail template',
    triggerEvent: 'client_created',
    actions: [
      {
        type: 'send_template',
        params: { follow_up_template_id: '' },
      },
    ],
  },
  {
    id: 'send-preparation',
    title: 'Send Preparation Package',
    description:
      'Give your clients everything they need to get ready for an upcoming session.',
    triggerLabel: 'Tag added',
    actionLabel: 'Send Mail template',
    triggerEvent: 'client_tag_added',
    conditionSummary: 'Any tag',
    actions: [
      {
        type: 'send_template',
        params: { follow_up_template_id: '' },
      },
    ],
  },
];
